var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarClassroomAdminGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.75 3.125H15.625C15.9562 3.12596 16.2736 3.25796 16.5078 3.49217C16.742 3.72639 16.874 4.04377 16.875 4.375V11.25H15.625V4.375H13.75V6.25H6.25V4.375H4.375V17.5H10V18.75H4.375C4.04377 18.749 3.72639 18.617 3.49217 18.3828C3.25796 18.1486 3.12596 17.8312 3.125 17.5V4.375C3.12596 4.04377 3.25796 3.72639 3.49217 3.49217C3.72639 3.25796 4.04377 3.12596 4.375 3.125H6.25V2.5C6.25096 2.16877 6.38296 1.85139 6.61717 1.61717C6.85139 1.38296 7.16877 1.25096 7.5 1.25H12.5C12.8312 1.25096 13.1486 1.38296 13.3828 1.61717C13.617 1.85139 13.749 2.16877 13.75 2.5V3.125ZM7.5 5H12.5V2.5H7.5V5ZM12.1313 15.3687L13.75 16.9874L17.8687 12.8687L18.75 13.7499L13.75 18.7499L11.25 16.2499L12.1313 15.3687Z",
    fill: "#878A93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarClassroomAdminGray);
export default __webpack_public_path__ + "static/media/sidebar-classroomAdmin-gray.34e56eb0d5a70d9a50a6dffe0e26616e.svg";
export { ForwardRef as ReactComponent };